import Header from "layout/Header/Header";
import Counter from "utils/Counter";

const Hero = () => {
  return (
    <section id="hero">
      <Header />
      <div className="particles_wrapper"></div>
      <div className="hero_content row column container">
        <iframe
          src="https://www.youtube.com/embed/_hpT5VNfGA0"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
        {/* ================ Top heading ============= */}
        <h2 data-aos="fade-up">
          Welcome to <div className="colored"> Web 3.0</div>
        </h2>
        {/* ================== secondary heading ======================= */}
        <h4 data-aos="fade-up" data-aos-delay="300" data-aos-duration="700">
          The revolution will not be televised, it will be{" "}
          <span className="colored"> livestreamed.</span>
        </h4>
        {/*  Countdown section  */}
        <div className="launch-date" data-aos="fade-down">
          <h2 style={{color: "#05FF00"}}>NFT Public Minting Now Live ✅</h2>
          <h3><span style={{color: "#8B00FF"}}>0.1 ETH </span> ➡️ First 1000 Mints</h3>
          <h3><span style={{color: "#8B00FF"}}>0.15 ETH </span> ➡️ All Remaining Mints</h3>
        </div>
        {/*============== CountDown Timer/Counter  =================*/}
        <div className="hero-counter">
          {/* ============= to change countdown date just add new date with time like this feb 27, 2022 18:00:00 ================ */}
          <Counter time="july 30, 2022 19:00:00" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
